/* eslint-disable */
// modalProps -- DatePicker 相关制定设置
// actionChange: 父级组件 回掉方法
import React, { useState, useEffect } from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { omit } from 'lodash'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const I2DatePicker = (props) => {
  const {
    propsClassName, propsClassSpan, style,// 样式 className
    modalProps, mode, label, picker,// 组件 功能参数
    query, value, searchKey, dateStrValue, dateOfType,// 组件 数据源
    path, clearKey, requestType, killPending, // 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props
  const handleValue = query[searchKey] ? dayjs(query[searchKey]) : null

  const [ useValue, setUseValue ] = useState(handleValue)
  useEffect(() => {
    // 当 query[searchKey] 为 null、undefined 或空字符串时，设置为 null，避免 dayjs(null) 导致 NaN
    const newValue = query[searchKey] ? dayjs(query[searchKey]) : null
    setUseValue(newValue)
  }, [query.refQ, query[searchKey]])

  const handleDatePicker = (e, eStr) => {
    // ---- 初始化数据 -----
    let formatValue = e
    console.log('formatValue', e, eStr)
    const formatConfig = [
      { key: 'startOf', format: +dayjs(e).startOf(picker || 'day') },
      { key: 'endOf', format: +dayjs(e).endOf(picker || 'day') },
      { key: 'defaultTime', format: +dayjs(e)}
    ]
    // ----- 处理数据 -----------
    switch (true) {
      case (!e): {
        formatValue = null
        break
      }
      // dateStrValue === true, 提交参数 为 字符串 根据 picker 类型
      case (dateStrValue): {
        formatValue = eStr
        break
      }
      // dateOfType === startOf | endOf | defaultTime,
      // 提交参数为，开始日| 结束日 去除时分秒，根据picker参数 ，或者 保留时分
      default: {
        const findKey = formatConfig.find(e => e.key === dateOfType)
        formatValue = findKey.format
        break
      }
    }
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: formatValue }
    )
  }
  return (
    <div className={propsClassName}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <DatePicker
        // picker = 'week'
        // picker = 'month'
        // picker = 'quarter'
        // picker = 'year'
        style={style}
        {...modalProps}
        value={useValue}
        onChange={handleDatePicker}
      />
    </div>
  )
}

export default I2DatePicker

I2DatePicker.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  picker: undefined,
  query: {},
  dateStrValue: false,
  dateOfType: 'startOf',
  killPending: false
}